import AceEditor from "react-ace";
import 'ace-builds/src-noconflict/mode-text';

import { EDITOR_VIEW_NAME, SOLUTION_AREA_STATE } from "../../core/constants";
import { translate } from "../../core/i18n";
import { store } from "../../core/state";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getComponentData, setComponentData } from "../../core/views";
import { Accordion } from "react-bootstrap";
import { AccordionToogle } from "./AccordionToggle";
import { solutionDataRestricted } from "../../features/restrictions";

export const solutionAreaShown = (editorState) => {
  const hasSolutionContent = (editorState.data?.projectContent?.solutionCode !== undefined);  
  return editorState.cfg?.editorFeatures?.solutionActive && hasSolutionContent && !solutionDataRestricted();  
}

export const needsSolutionAfterErrors = (editorState) => {
  if (editorState?.cfg.editorFeatures.showSolutionAfterErrors > 0) {
    if (editorState?.data?.errorCounter === undefined || editorState?.data?.errorCounter < editorState?.cfg.editorFeatures.showSolutionAfterErrors) return false;
  }
  return true;
}

export const triggerShowSolutionArea = () => {
  const solutionAreaState = getComponentData(SOLUTION_AREA_STATE);
  const newSolutionAreaState = { ...solutionAreaState, show: true };
  setComponentData(SOLUTION_AREA_STATE, newSolutionAreaState);
}

export const SolutionAccordion = (props) => {  
  const [editorState] = store.useState(EDITOR_VIEW_NAME);

  if (!editorState?.project?.solution || !editorState?.data?.projectContent.solutionCode) return null;
  if (!needsSolutionAfterErrors(editorState)) return null;

  const options = {
    readOnly: true,
    fontSize: "15px",
    theme: "ace/theme/clouds"
  }

  const solutionCode = editorState?.data?.projectContent.solutionCode;
  const infoCard = (<>
    <hr/>
    <AccordionToogle eventKey="3">
      <div className="col-6 fakeLink"><FontAwesomeIcon icon="key" /> {translate('view-editor-solution-button')}</div>
    </AccordionToogle>        
    <Accordion.Collapse eventKey="3">
        <AceEditor className="card-body"
          mode={"text"}
          name="solution"                            
          value={solutionCode}
          setOptions={options}
          width={props.width}
        />            
    </Accordion.Collapse>
  </>);

  return (solutionAreaShown(editorState) && infoCard);
}